import perfilRoute from './perfil';
import instituicaoRoute from './instituicao';
import orgaoRoute from './orgao';
import ambienteRoute from './ambiente';
import moduloRoute from './modulo';
import controladorRoute from './controlador';
import permissaoRoute from './permissao';
import menuRoute from './menu';
import usuariosRoute from './usuario';
import pessoaRoute from './pessoa';
import configuracaoRoute from './configuracao';
import bairroRoute from './bairro';
import logradouroRoute from './logradouro';
import relatorioRoute from './relatorio';

export default {
  perfilRoute,
  instituicaoRoute,
  orgaoRoute,
  ambienteRoute,
  moduloRoute,
  controladorRoute,
  permissaoRoute,
  menuRoute,
  usuariosRoute,
  pessoaRoute,
  configuracaoRoute,
  bairroRoute,
  logradouroRoute,
  relatorioRoute,
};
